import React, { Component } from 'react';
import { Icon } from 'react-materialize';
import LineChart from './LineChart';
import { connect } from 'react-redux';


class LineChartCollapsible extends Component {
  constructor(props) {
   super(props);
   this.state = {
     collapsible: true
   }
 }

 onClickCollapsible(){
   let temp = this.state.collapsible;
   this.setState({ collapsible: !temp })
 }

 openCollapsible(){
   this.setState({ collapsible: true})
 }

 componentWillReceiveProps(nextProps){
     var rthis = this;
     this.setState({ collapsible: false})
     setTimeout(function(){ rthis.openCollapsible()  }, 500);
 }




render() {
  const { countries, age, gender } = this.props;
  return (
    <div className="map-view-collapsible">
      <div className="map-view-collapsible-title" onClick={() => this.onClickCollapsible()}>
        <div className="view-text">
          <span style={{display: 'flex', alignItems: "center"}}>
            Trends
          </span>
          <span className="message">
             Select up to two genders, up to two ages, and up to 10 countries to view the line chart.
              <br/>Note: Countries without multiple data points will only display as single dots.
            </span>
        </div>
        <div className="view-icon">
          {
            this.state.collapsible? <Icon>keyboard_arrow_up</Icon>:<Icon>keyboard_arrow_down</Icon>
          }
        </div>
      </div>
      <div>
        {
          this.state.collapsible? <LineChart />: ""
        }
      </div>
    </div>
  )}
}



function mapStateToProps(state){
  return {
    gender: state.gender,
    countries: state.countries,
    age: state.age,
  }
};

export default connect(mapStateToProps, null)(LineChartCollapsible);

//export default LineChartCollapsible;



// WEBPACK FOOTER //
// ./src/components/LineChartCollapsible.js